import companyIcon from "../assets/CompanyIcon.jpeg";

function Hero() {
  const scrollToProducts = () => {
    document.getElementById('products').scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="hero" style={{ backgroundImage: `url(${companyIcon})` }}>
      <div className="hero-overlay">
        <div className="hero-content">
          <h1 className="hero-title">Pure & Powerful Cleaning Solutions</h1>
          <p className="hero-subtitle">
            Experience the perfect blend of nature and science. Our premium cleaning
            products deliver exceptional results while caring for your home and the environment.
          </p>
          <div className="hero-buttons">
            <button className="btn btn-primary" onClick={scrollToProducts}>
              Explore Products
            </button>
            <button className="btn btn-secondary" onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}>
              Contact Us
            </button>
          </div>
        </div>
        <div className="hero-features">
          <div className="feature-badge">
            <span className="badge-icon">🌿</span>
            <span className="badge-text">Eco-Friendly</span>
          </div>
          <div className="feature-badge">
            <span className="badge-icon">💪</span>
            <span className="badge-text">Powerful Clean</span>
          </div>
          <div className="feature-badge">
            <span className="badge-icon">✨</span>
            <span className="badge-text">Safe Formula</span>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
